import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from '@/services'
import zhCN from 'vee-validate/dist/locale/zh_CN';
import VeeValidate, { Validator } from 'vee-validate';
import '@/filter'
import Md from '@/utils'
// import './utils/wxBackListener'
import './assets/font/iconfont'
import '@/utils/iosStopBig.js'
import '@/utils/DateUtils.js'
import {
  Icon,
  Cell,
  CellGroup,
  NavBar,
  Tab,
  Tabs,
  Tag,
  Button,
  Search,
  Field,
  Checkbox,
  CheckboxGroup,
  Image,
  Uploader,
  Lazyload,
  Dialog,
  RadioGroup,
  Radio,
  ImagePreview,
  Popup,
  Circle,
  Loading,
  Area
} from 'vant';
import '@/assets/scss/index.scss'

Vue.use(Icon)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(NavBar)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(Tag)
Vue.use(Button)
Vue.use(Search)
Vue.use(Field)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Uploader)
Vue.use(Image)
Vue.use(Dialog)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(ImagePreview)
Vue.use(Popup)
Vue.use(Circle)
Vue.use(Loading)
Vue.use(Area)
Vue.use(Lazyload, {
  lazyComponent: true
})

const dictionary = {
  zh_CN: {
    messages: {
      required: (field) => { return `请输入${field}` }
    }
  }
}

Validator.localize('zh-CN', zhCN)

Validator.extend('mobile', {
  getMessage: field => field + '无效',
  validate: value => /^[1][0-9]{10}$/.test(value)
})

Vue.use(VeeValidate, {
  locale: 'zh-CN',
  dictionary: {
    'zh-CN': dictionary.zh_CN
  }
})

Vue.use(Md)

Vue.config.productionTip = false

Vue.prototype.$api = axios.request

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
